export const MARKS = { 1: '1%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' };
